import axios from "axios";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import Footer from "../../Components/Footer/Footer";
import Register from "../../Components/Register/Register";
import Hero from "./Hero/Hero";
import Tier1 from "./Tiers/Tier1";
import Tier2 from "./Tiers/Tier2";
import Tier3 from "./Tiers/Tier3";
import TiersModal from "./Tiers/TiersModal";

import "./Join.scss";

const Join = () => {
  const navigate = useNavigate();
  const refTier2 = useRef(null);
  const refTier3 = useRef(null);
  const [refetch, setRefecth] = useState(false);
  const [userStatus, setUserStatus] = useState(null);
  const [show, setShow] = useState(false);

  const onUpdate = (status) => {
    setRefecth(status);
  };

  const openModal = (status) => {
    setShow(!show);
  };

  const fetchUserProfile = async () => {
    const response = await axios
      .get(`${process.env.REACT_APP_EDAIN_URL}/api/v1/bazaar/partner/private/profile`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("jwt")}`
        }
      })
      .catch((error) => {
        if (error.response) {
          switch (error.response.status) {
            case 401:
              localStorage.removeItem("jwt");
              navigate("/register");
              break;
          }
        }
      });
    if (response?.status === 200) {
      setUserStatus(response.data.status);

      if (
        response?.data?.status === "UNASSIGNED" ||
        response?.data?.status === "AVAILABLE" ||
        response?.data?.status === "UNAVAILABLE" ||
        response?.data?.status === "UNASSIGNED" ||
        response?.data?.status === "ASSIGNED"
      ) {
        navigate("/status");
      }
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, [refetch]);

  return (
    <div className="join-page">
      <Hero />
      <div className="section-padding">
        <div className="large-container">
          {userStatus === "PENDING" ? (
            <>
              <div className="mt-5 pt-5 d-md-block d-none"></div>

              <Tier1 refTier2={refTier2} openModal={openModal} onUpdate={onUpdate} />

              <div ref={refTier2} className="mt-5">
                <Tier2
                  refTier3={refTier3}
                  openModal={openModal}
                  onUpdate={onUpdate}
                  refetch={refetch}
                />
              </div>

              <div ref={refTier3} className="mt-5">
                <Tier3 openModal={openModal} refetch={refetch} />
              </div>
            </>
          ) : null}
        </div>
      </div>

      <TiersModal show={show} toggleModal={() => setShow(false)} />

      <Register />
      <Footer />
    </div>
  );
};
export default Join;
